<template>
  <div class="account-container">
    <el-tooltip :enterable="false" placement="top" :content="name" :disabled="!tooltip">
      <div class="account-content">
        <div class="account-image" :class="image_class">
          <img v-if="display_image" class="account-image-img" :src="display_image" alt="" @error="is_error = true" />
          <div v-if="!isHideSymbol && symbol !== ''" :class="symbol_class">
            <Icon :name="symbol" />
          </div>
        </div>
        <div v-if="isDisplayName" class="account-name">{{ name }}</div>
      </div>
    </el-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'

export default defineComponent({
  components: { Icon },
  props: {
    name: {
      type: String,
      required: true
    },
    isDisplayName: {
      type: Boolean,
      default: true
    },
    image: {
      type: String as PropType<string | null>,
      default: null
    },
    symbol: {
      // TODO Xとtwitterについてはどちらが主流になっているのかわからないため、利用ケースを整理して統一できるまでは両対応とする
      type: String as PropType<'X' | 'twitter' | 'instagram' | 'tiktok' | ''>,
      default: ''
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    isHideSymbol: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_error: false
    }
  },
  watch: {
    image() {
      this.is_error = false
    }
  },
  computed: {
    symbol_class(): string[] {
      return ['account-symbol', `symbol-${this.symbol}`]
    },
    display_image(): string | null {
      if (!this.image || this.is_error) return null
      return this.image
    },
    image_class(): { 'is-twitter': boolean; 'is-instagram': boolean; 'is-tiktok': boolean; 'has-image': boolean } {
      return {
        'is-twitter': this.symbol === 'twitter' || this.symbol === 'X',
        'is-instagram': this.symbol === 'instagram',
        'is-tiktok': this.symbol === 'tiktok',
        'has-image': this.display_image !== null
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.account-container {
  display: flex;
  align-items: center;
}

.account-content {
  display: flex;
  align-items: center;
  max-width: $spacing-unit * 31;

  .account-image {
    position: relative;
    display: block;
    width: $spacing-unit * 4;
    height: $spacing-unit * 4;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-radius: 50%;

    &.is-twitter {
      background-image: url('@/client/assets/images/twitter_default_profile.png');
    }

    &.is-instagram {
      background-image: url('@/client/assets/images/instagram_default_profile.png');
    }

    &.is-tiktok {
      background-image: url('@/client/assets/images/tiktok_default_profile.png');
    }

    &.has-image {
      background-image: none;
    }
  }

  .account-image-img {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .account-symbol {
    position: absolute;
    right: 1px;
    bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: $spacing-unit * 2;
    height: $spacing-unit * 2;
    border-radius: 50%;

    .size-normal {
      width: 12px;
      height: 12px;
      font-size: 12px;
    }
  }

  .symbol-twitter {
    color: #fff;
    background-color: $twitter-color;
  }

  .symbol-instagram {
    color: #fff;
    background-color: $instagram-color;
  }

  .account-name {
    max-width: $spacing-unit * 20;
    margin-left: $spacing-unit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
